<template>
    <div ref="zoom_down"></div>
</template>

<script>
import ZoomDown from "!!raw-loader!../../assets/ricoh_assets/icons/ICN004-04_zoom_down.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.zoom_down.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = ZoomDown

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>

</style>